import React from "react";
import WantToReadButton from "../../want_to_read/want_to_read_button";
import { TRACKED_CLASSES_AUDIBLE } from "../../../modules/ads/click_tracking_helper";
import GrComponentFactory from "../../gr_component_factory";
import BookDescription from "../../book_description";
import CommunityRating from "../../community_rating";
import { random } from "lodash";

export default GrComponentFactory.createClass({
  displayName: "AudiobookTooltip",
  propTypes: {
    bookId: React.PropTypes.string,
    title: React.PropTypes.string,
    bookAci: React.PropTypes.string,
    requestOriginUrl: React.PropTypes.string,
    randomRequestParam: React.PropTypes.string,
    imageUrl: React.PropTypes.string,
    audiobookHost: React.PropTypes.string,
    bookUrl: React.PropTypes.string,
    author: React.PropTypes.object,
    description: React.PropTypes.object,
    avgRating: React.PropTypes.number,

    //properties passed to the children describing the behavior of
    //the parent
    currentSlide: React.PropTypes.number,
    tooltipIndex: React.PropTypes.number,
    slidesToShow: React.PropTypes.number,
  },

  getDefaultProps () {
    return {
      trackingOptions: {
        enableTracking: true,
      },
    };
  },

  render () {

    const wantToReadProps = {
      bookId: this.props.bookId.toString(),
      bookTitle: this.props.title,
      uniqueId: random(1000000).toString(),
      showStars: true,
      showMenu: true,
      trackingOptions: TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Carousel_WantToRead,
    };

    return (<div ref="toolTip" className="gr-carousel-tooltipAudioBook">
      <h2>
        <a className="gr-carousel-tooltipAudioBook-bookTitle" href={this.props.bookUrl}>{this.props.title}</a>
      </h2>
      by <a className="gr-carousel-tooltipAudioBook-authorName" href={this.props.author.profileUrl}>{this.props.author.name}</a>
      {this.props.author.isGoodreadsAuthor ? "*" : null}
      <CommunityRating rating={parseFloat(this.props.avgRating)}
                       displayAvg={true}/>
      <BookDescription bookDescription={this.props.description}/>
      <div className="gr-carousel-wantToRead-SpacingLeft">
        <WantToReadButton
            {...wantToReadProps} />
      </div>
    </div> );
  },
});
